export default function BenchmarkGraphConfigService() {
  return {
    getMiniOverrides: function () {
      return {
        chart: {
          width: 75,
          height: 60
        },
        xAxis: {
          lineWidth: 1,
          labels: {
            enabled: false
          }
        },
        plotOptions: {
          series: {
            marker: {
              lineWidth: 1,
              radius: 6
            },
            lineWidth: 2
          }
        },
        tooltip: {
          enabled: false
        }
      };
    },

    getSmallOverrides: function () {
      return {
        chart: {
          width: 170,
          height: 125
        },
        xAxis: {
          lineWidth: 1,
          labels: {
            enabled: false
          }
        },
        plotOptions: {
          series: {
            marker: {
              lineWidth: 1,
              radius: 6
            },
            lineWidth: 2
          }
        },
        tooltip: {
          enabled: false
        }
      };
    },
    getMediumOverrides: function () {
      return {
        chart: {
          width: 400,
          height: 200
        },
        xAxis: {
          lineWidth: 1,
          labels: {
            enabled: true
          }
        }
      };
    },
    getLargeOverrides: function () {
      return {
        chart: {
          width: 500,
          height: 250
        },
        xAxis: {
          lineWidth: 2,
          tickInterval: 10,
          labels: {
            enabled: true,
            y: 20,
            style: {
              color: '#929396',
              fontSize: '13px'
            },
            maxStaggerLines: 1,
            step: 1,
            formatter: function () {
              var val = 100 - this.value;

              return val + '%';
            }
          }
        },
        plotOptions: {
          series: {
            marker: {
              enabled: false,
              lineWidth: 2,
              radius: 10,
              lineColor: '#FFFFFF', // inherit from series
              states: {
                hover: {
                  enabled: false
                }
              },
              symbol: 'circle'
            },
            lineWidth: 4
          }
        },
        tooltip: {
          enabled: true
        }
      };
    },
    getImpactOverrides: function () {
      return {
        chart: {
          width: 340,
          height: 180
        },
        xAxis: {
          lineWidth: 1,
          labels: {
            enabled: true,
            style: {
              fontSize: '10px'
            },
            formatter: function () {
              var val = 100 - this.value;

              return val + '%';
            }
          },
          tickInterval: 10
        },
        plotOptions: {
          series: {
            marker: {
              lineWidth: 1,
              radius: 6
            },
            lineWidth: 2
          }
        },
        tooltip: {
          enabled: false
        }
      };
    },
    getModalOverrides: function () {
      return {
        chart: {
          width: 516,
          height: 270
        },
        xAxis: {
          lineWidth: 1,
          labels: {
            enabled: true,
            style: {
              fontSize: '13px'
            }
          },
          tickInterval: 10
        },
        plotOptions: {
          series: {
            marker: {
              enabled: false,
              lineWidth: 2,
              radius: 10,
              lineColor: '#FFFFFF', // inherit from series
              states: {
                hover: {
                  enabled: false
                }
              },
              symbol: 'circle'
            },
            lineWidth: 4
          }
        },
        tooltip: {
          enabled: true
        }
      };
    },
    getDefaultOverrides: function () {
      return {
        chart: {
          width: 200,
          height: 120
        }
      };
    },
    getDefaultBellCurveGraphConfig: function (series) {
      return {
        chart: {
          type: 'spline',
          animation: false
        },
        credits: {
          enabled: false
        },
        title: null,
        yAxis: {
          gridLineWidth: 0,
          minorGridLineWidth: 0,
          labels: {
            enabled: false
          },
          title: null
        },
        xAxis: {
          lineWidth: 2,
          lineColor: '#929396',
          labels: {
            y: 20,
            style: {
              color: '#929396',
              fontSize: 20
            },
            maxStaggerLines: 1,
            step: 1,
            formatter: function () {
              var val = 100 - this.value;

              return val + '%';
            }
          },
          tickColor: '#FFF'
        },
        plotOptions: {
          series: {
            marker: {
              enabled: false,
              lineWidth: 2,
              radius: 10,
              lineColor: '#FFFFFF', // inherit from series
              states: {
                hover: {
                  enabled: false
                }
              },
              symbol: 'circle'
            },
            lineWidth: 4
          },
          areaspline: {
            fillColor: '#F00',
            enableMouseTracking: false
          },
          scatter: {
            fillColor: '#F00'
          },
          spline: {
            enableMouseTracking: false
          }
        },
        tooltip: {
          useHTML: true,
          borderRadius: 16,
          borderColor: '#CDCECF',
          backgroundColor: '#FFFFFF',
          formatter: function () {
            return (
              '<span style="font-size:22px">' +
              (100 - this.x) +
              '%</span><br /><span style="color: #999;">Benchmark</span>'
            );
          }
        },
        series: series
      };
    }
  };
}
